import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { SUBSCRIPTION_PLAN_2 } from 'constants/paths';
import { useGetSubscriptionDetails } from 'services/payments/subscriptions/hooks';
import { useUserStore } from 'store/useUserStore';
import { getAuthUser } from 'store/useUserStore/selectors';
import { useUserSubscriptionStore } from 'store/useUserSubscriptionStore';
import { getSetIsSubscriptionLoading, getSetUserSubscription } from 'store/useUserSubscriptionStore/selectors';

import { useAuthenticated } from 'hooks/useAuthenticated';

import { IUserSubscriptionResponse } from 'interfaces/subscriptions';

import ToastService from 'helpers/ToastService';

import { IAuthUserSubscriptionProviderProps } from './types';

export const AuthUserSubscriptionProvider: React.FC<IAuthUserSubscriptionProviderProps> = ({ children }) => {
  const authUser = useUserStore(getAuthUser);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const pSignUp = searchParams.get('pSignUp');

  const setIsLoading = useUserSubscriptionStore(getSetIsSubscriptionLoading);
  const setUserSubscription = useUserSubscriptionStore(getSetUserSubscription);

  const { isAuthenticated } = useAuthenticated();

  const { data, isLoading, error, isFetching } = useGetSubscriptionDetails({ enabled: !!authUser && isAuthenticated });

  const [onlyPayedSignUp, setOnlyPayedSignUp] = useState(localStorage.getItem('onlyPayedSignUp') || pSignUp);

  useEffect(() => {
    if (pSignUp) {
      setOnlyPayedSignUp(pSignUp);
    }
  }, [pSignUp]);

  if (data && (data as IUserSubscriptionResponse)?.currentSubscription?.subscriptionPlan !== 'FREE') {
    localStorage.removeItem('onlyPayedSignUp');
  }

  useEffect(() => {
    if (data && !isFetching) {
      setUserSubscription(data as IUserSubscriptionResponse);

      if ((data as IUserSubscriptionResponse).currentSubscription?.subscriptionPlan === 'FREE' && onlyPayedSignUp) {
        navigate(SUBSCRIPTION_PLAN_2);
      }
    }
  }, [data, isFetching, onlyPayedSignUp]);

  useEffect(() => {
    setIsLoading(isLoading);
  }, [isLoading]);

  useEffect(() => {
    if (error) {
      ToastService.showError(error.message);
    }
  }, [error]);

  return <>{children}</>;
};
